const React = require("react");

const ActionCreators = require("../actionCreators/FileSelectionActionCreators.js");

const File = require("../types/File.js");

const FileIcon = require("./FileIcon.jsx");
const RemoveButton = require("./RemoveButton.jsx");
const UploadingMark = require("./UploadingMark.jsx");

const styles = {
    Normal: {
        Icon: {
            display: "block",
            fontSize: 71,
            marginBottom: 10,
            color: "#480",
            textShadow: "0 3px 5px #bbb"
        },
        Figure: {
            textAlign: "center"
        },
        Remove: {
            position: "absolute",
            top: 45,
            left: -8,
            boxShadow: "0 3px 5px #888"
        },
        Uploading: {
            position: "absolute",
            top: 45,
            left: -3
        },
        IconWrapper: {
            position: "relative",
            display: "inline-block",
            width: 65
        }
    },
    ErrorStyle: {
        color: "#d80"
    },
    ErrorMessage: {
        textTransform: "uppercase",
        color: "#444",
        fontFamily: "monospace",
        fontWeight: "bold",
        fontSize: "18px",
        borderRadius: "6px",
        marginLeft: "5px",
        marginRight: "5px",
    }
};

const SelectedFile = React.createClass({
    propTypes: {
        File: File.Type.isRequired
    },
    getInitialState() {
        return {
            IsHovering: false
        };
    },
    render() {
        const styleSet = this.GetStyles();

        const figureStyle = Object.assign({}, (this.props.style || {}), styleSet.Figure);

        const size = Math.ceil(this.props.File.BaseFile.size / 1024.00);

        const onRemove = this.GetOnRemove(this.props.File);
        
        return (<figure style={figureStyle}>
            <div style={styleSet.IconWrapper} onMouseOver={this.MouseOver} onMouseOut={this.MouseOut}>
                <FileIcon style={styleSet.Icon} />
                {!this.props.File.IsUploading
                && (<RemoveButton style={styleSet.Remove} onClick={onRemove } />)}
                {this.props.File.IsUploading
                && (<UploadingMark style={styleSet.Uploading} />)}
            </div>
            <div>{this.props.File.BaseFile.name}</div>
            <div style={{fontFamily: "monospace"}}>{size} KB</div>
            {this.props.File.IsInvalid
            && (<div style={styles.ErrorMessage }>[{this.props.File.Message}]</div>)}
        </figure>);
    },
    MouseOver() {
        this.setState({ IsHovering: true });
    },
    MouseOut() {
        this.setState({ IsHovering: false });
    },
    GetOnRemove(file) {
        return () => {
            ActionCreators.Remove(file);
        };
    },
    GetStyles() {
        const baseStyleSet = Object.assign({}, styles.Normal);
        var reducers = [];
        
        if(this.state.IsHovering) {
            reducers.push((prev) => {
                const result = Object.assign({}, prev, {
                    Icon: Object.assign({}, prev.Icon, {
                        position: "relative",
                        top: -2,
                        textShadow: "0 8px 10px #999"
                    }),
                    Remove: Object.assign({}, styles.Normal.Remove, {
                        top: styles.Normal.Remove.top - 2,
                        textShadow: "0 9px 11px #666"
                    })
                });

                return result;
            });
        }

        if (this.props.File.IsInvalid
            || this.props.File.IsUploading) {
            reducers.push((prev) => {
                const result = Object.assign({}, prev, {
                    Icon: Object.assign({}, prev.Icon, {
                        color: "#d80"
                    })
                });

                return result;
            });
        }
        
        const reduce = (styleSet, rest) => {
            if (!rest || rest.length === 0) {
                return styleSet;
            }

            return reduce(rest[0](styleSet), rest.slice(1));
        };

        const result = reduce(baseStyleSet, reducers);

        return result;
    }
});

module.exports = SelectedFile;


// WEBPACK FOOTER //
// ./src/components/SelectedFile.jsx